/**
 * Docelowe miejsce generowanego załącznika/dokumentacji
 *
 * @export
 * @enum {number}
 */
export enum GenerateTarget {
  /**
   * Procedura
   */
  PROCEDURE = 1,
  /**
   * Dokument/wniosek
   */
  DOCUMENT = 2
}
